import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialog } from "../../shared/confirm-dialog.component";
import { IDataService } from "../../core/base.dataservice";
import { ISettingsEntity } from "./settings.entity";
import { CrewErrorDialog } from "../../core/crew-error-dialog.component";

export abstract class DetailsBase<TEntity extends ISettingsEntity, TDataService extends IDataService<TEntity> = IDataService<TEntity>> {
    constructor(
        private stateService: StateService,
        private dialog: MatDialog,
        public entity: TEntity,
        private dataService: TDataService,
        private $log: ng.ILogService) { }

    public abstract entityName: string;

    public abstract editStateName: string;

    public abstract listStateName: string;

    public edit(): void {
        this.stateService.go(this.editStateName, { id: this.entity.Id });
    }

    public delete(): void {

        var self = this;

        this.dialog
            .open(ConfirmDialog)
            .afterClosed()
            .subscribe(res => self.onDeleteEntity(self, res));
    }

    private onDeleteEntity(self: DetailsBase<TEntity>, shouldDelete?: boolean) {
        if (shouldDelete) {
            self.dataService
                .delete(self.entity)
                .then(() => self.backToList())
                .catch(err => self.handleError(err));
        }
    }

    public backToList(): Promise<any> {
        return this.stateService.go(this.listStateName);
    }

    private handleError(err: any): Promise<void> {
        const errorMessage = "Error deleting " + this.entityName;
        this.$log.error(errorMessage + ".\n\nError is: " + err);

        const dialogRef = this.dialog.open(CrewErrorDialog);
        dialogRef.componentInstance.title = "Error occurred";
        dialogRef.componentInstance.contentStart = errorMessage + ". Check if there are items related to this " + this.entityName + " still in use.";

        let mainContent = err.message ? err.message + "\n\n" : "";
        mainContent += err.longStack || err.stack ? err.longStack || err.stack : err;

        dialogRef.componentInstance.mainContent = mainContent;

        return dialogRef.afterClosed().toPromise().then(() => window.location.reload(true));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/shared/details.base.ts